<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>TEST SOFTPHONE</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <ul class="nav nav-pills flex-column">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#register">
              <i class="fa fa-user-cog fa-fw" aria-hidden="true"></i> Register
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="'nav-link' + (sip.registered ? '' : ' disabled')"
              data-toggle="tab"
              href="#phone"
            >
              <i class="fa fa-phone fa-fw" aria-hidden="true"></i> Phone
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled" data-toggle="tab" href="#messages">
              <i class="fa fa-comments fa-fw" aria-hidden="true"></i> Messages
            </a>
          </li>
        </ul>
      </div>
      <div class="col-6">
        <div class="tab-content">
          <div class="tab-pane fade show active" id="register" role="tabpanel">
            <form v-if="!sip.registered">
              <div class="form-group">
                <label for="txtSipUser">User</label>
                <input type="text" class="form-control" id="txtSipUser" v-model="sip.user" />
              </div>
              <div class="form-group">
                <label for="txtSipPassword">Password</label>
                <input type="text" class="form-control" id="txtSipPassword" v-model="sip.password" />
              </div>
              <button type="button" class="btn btn-hub-primary" @click="register()">Register</button>
            </form>
            <div v-else>REGISTERED AS {{ sip.user }}</div>
          </div>
          <div class="tab-pane fade" id="phone" role="tabpanel">
            <video ref="remoteMedia"></video>
            <video ref="localMedia"></video>
            <input
              type="text"
              class="form-control"
              id="txtDialedNum"
              v-model="dialed_num"
              v-if="!sip.in_call && !sip.ringing"
            />
            <button
              type="button"
              class="btn btn-success"
              @click="answer()"
              v-if="sip.ringing"
            >Answer</button>
            <button
              type="button"
              class="btn btn-success"
              @click="call()"
              v-if="!sip.in_call && !sip.ringing"
            >Call</button>
            <button type="button" class="btn btn-danger" @click="end()" v-if="sip.in_call">End</button>
          </div>
          <div class="tab-pane fade" id="messages" role="tabpanel">Messages go here</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SimpleUser } from 'sip.js/lib/platform/web'

export default {
  name: 'SoftPhoneIndex',
  data: function () {
    return {
      sip: {
        user: '',
        password: '',
        registered: false,
        ringing: false,
        in_call: false,
        phone: {},
        current_session: {}
      },
      dialed_num: '1040'
    }
  },
  methods: {
    register () {
      let context = this
      context.$refs.localMedia.muted = true

      context.sip.phone = new SimpleUser(
        'wss://twohundred.phoenixbell.online:7443',
        {
          aor: 'sip:' + context.sip.user + '@twohundred.phoenixbell.online',
          media: {
            constraints: { audio: true, video: false },
            remote: {
              audio: context.$refs.remoteMedia,
              video: context.$refs.remoteMedia
            },
            local: { video: context.$refs.localMedia }
          },
          userAgentOptions: {
            authorizationPassword: context.sip.password,
            forceRport: true,
            sessionDescriptionHandlerFactoryOptions: {
              peerConnectionOptions: {
                rtcConfiguration: {
                  iceServers: [
                    { urls: 'stun:stun.phoenixbell.online:3478' },
                    { urls: 'turn:stun.phoenixbell.online:3478?transport=udp', username: 'phxuser', credential: '8750S@ge' }
                  ]
                }
              }
            }
            // sessionDescriptionHandlerFactory: function(session,options) {
            //   let sdh = new SessionDescriptionHandler(session, options);
            //   sdh.getDescription = function (options, modifiers) { }
            //   sdh.setDescription = function (sdp, options, modifiers) {
            //       options.peerConnectionOptions.rtcConfiguration.iceServers = [
            //         { urls: "stun:stun.phoenixbell.online:3478" }
            //       ];
            //     }
            //   sdh.hasDescription = function (contentType) { }
            //   sdh.close = function () { }
            //   sdh.holdModifier = function (description) { }
            //   sdh.sendDtmf = function (tones, options) { }
            //   sdh.getDirection = function () { }

            //   return sdh
            // }
          }
        }
      )

      context.sip.phone.delegate = {
        onRegistered: () => {
          context.sip.registered = true
        },
        onUnregistered: () => {
          context.sip.registered = false
        },
        onCallCreated: () => {
          context.sip.in_call = true
        },
        onCallAnswered: () => {
          context.sip.ringing = false
          context.sip.in_call = true
        },
        onCallHangup: () => {
          context.sip.in_call = false
        },
        onCallReceived: () => {
          context.sip.ringing = true
        }
      }

      context.sip.phone.connect()
      context.sip.phone.register()
    },
    call () {
      let context = this
      context.sip.phone.call(
        'sip:' + context.dialed_num + '@twohundred.phoenixbell.online'
      )
    },
    answer () {
      let context = this
      context.sip.phone.answer()
    },
    end () {
      let context = this
      context.sip.phone.hangup()
    }
  }
}
</script>

<style scoped>
</style>
